module.exports = {
	"thousands": {
		"en": "k"
	},
	"millions": {
		"en": "m"
	},
	"billions": {
		"en": "b"
	},
	"trillions": {
		"en": "t"
	},
	"largeValue": {
		"en": "Large Value"
	},
	"largeBlend": {
		"en": "Large Blend"
	},
	"largeGrowth": {
		"en": "Large Growth"
	},
	"midValue": {
		"en": "Mid Value"
	},
	"midBlend": {
		"en": "Mid Blend"
	},
	"midGrowth": {
		"en": "Mid Growth"
	},
	"smallValue": {
		"en": "Small Value"
	},
	"smallBlend": {
		"en": "Small Blend"
	},
	"smallGrowth": {
		"en": "Small Growth"
	},
	"january": {
		"en": "January"
	},
	"february": {
		"en": "February"
	},
	"march": {
		"en": "March"
	},
	"april": {
		"en": "April"
	},
	"may": {
		"en": "May"
	},
	"june": {
		"en": "June"
	},
	"july": {
		"en": "July"
	},
	"august": {
		"en": "August"
	},
	"september": {
		"en": "September"
	},
	"october": {
		"en": "October"
	},
	"november": {
		"en": "November"
	},
	"december": {
		"en": "December"
	},
	"basicMaterial": {
		"en": "Basic Material"
	},
	"communicationServices": {
		"en": "Communication Services"
	},
	"consumerCyclical": {
		"en": "Consumer Cyclical"
	},
	"consumerDefensive": {
		"en": "Consumer Defensive"
	},
	"energy": {
		"en": "Energy"
	},
	"financialServices": {
		"en": "Financial Services"
	},
	"healthcare": {
		"en": "Healthcare"
	},
	"industrials": {
		"en": "Industrials"
	},
	"realEstate": {
		"en": "Real Estate"
	},
	"technology": {
		"en": "Technology"
	},
	"utilities": {
		"en": "Utilities"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/config/default-base-labels.json
 ** module id = 114
 ** module chunks = 0
 **/